export const handleLinkTarget = (isExternalLocation) => {
    if (isExternalLocation) {
        return "_blank";
    }
    return "_self";
};
